const Backbone = require('backbone');
const RecommendedOptionFinishModel = require('app/models/store/client/product/recommendedoptionfinish');
const RecommendedOptionFinishCollection = Backbone.Collection.extend({
	model: RecommendedOptionFinishModel,

	initialize: function() {
		this.listenTo(Backbone, 'recommendedOptionFinish:clicked', this.setSelectedFinish);
	},

	/**
	 * setSelectedFinish - set the currently selected finish
	 * @param  {Object} data     The new selected finish model
	 * @return {void}
	 */
	setSelectedFinish: function(data) {
		const selectedFinish = this.getFinishByUniqueId(data.uniqueId);
		if (selectedFinish) {
			this.each(function(model) {
				model.set({
					selected: false
				});
			});

			selectedFinish.set({
				selected: true
			});
		}
	},
	/**
	 * @param {*} data
	 * @return {void}
	 */
	setSelectedFinishByUniqueId: function(data) {
		this.setSelectedFinish({
			uniqueId: data.uniqueId,
			finish: data.finish
		});
	},
	/**
	 * getFinishByUniqueId - get the Finish model by UniqueId
	 * @template T
	 * @param {T} uniqueId
	 * @return {{uniqueId: T; [key: string]: any} | undefined} Finish Model
	 */
	getFinishByUniqueId: function(uniqueId) {
		return this.findWhere({
			uniqueId: uniqueId
		});
	},

	/**
	 * getFinishByUniqueId - get the Finish model by UniqueId
	 * @param {String} finish
	 * @return {{finish: string; [key: string]: any}[]} Finish Model
	 */
	getFinishByName: function(finish) {
		return this.where({
			finish
		});
	}
});

module.exports = RecommendedOptionFinishCollection;
